var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1287_2306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 3.58984H9.20508C6.09896 3.58984 3.58008 6.10871 3.58008 9.21483V15.9649C3.58008 19.071 6.09896 21.5899 9.20508 21.5899H15.9551C19.0612 21.5899 21.5801 19.071 21.5801 15.9649V9.21483C21.5801 6.10871 19.0612 3.58984 15.9551 3.58984ZM19.8926 15.9649C19.8926 18.1361 18.1263 19.9024 15.9551 19.9024H9.20508C7.03383 19.9024 5.26758 18.1361 5.26758 15.9649V9.21483C5.26758 7.04358 7.03383 5.27733 9.20508 5.27733H15.9551C18.1263 5.27733 19.8926 7.04358 19.8926 9.21483V15.9649Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5801 8.08984C10.0949 8.08984 8.08008 10.1047 8.08008 12.5899C8.08008 15.075 10.0949 17.0899 12.5801 17.0899C15.0652 17.0899 17.0801 15.075 17.0801 12.5899C17.0801 10.1047 15.0652 8.08984 12.5801 8.08984ZM12.5801 15.4024C11.0298 15.4024 9.76758 14.1401 9.76758 12.5899C9.76758 11.0385 11.0298 9.77734 12.5801 9.77734C14.1304 9.77734 15.3926 11.0385 15.3926 12.5899C15.3926 14.1401 14.1304 15.4024 12.5801 15.4024Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.418 8.35207C17.7492 8.35207 18.0176 8.08362 18.0176 7.75245C18.0176 7.42129 17.7492 7.15283 17.418 7.15283C17.0869 7.15283 16.8184 7.42129 16.8184 7.75245C16.8184 8.08362 17.0869 8.35207 17.418 8.35207Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1287_2306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.580078 0.589844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.32f9bdc0fde51380e692ab0797d1690b.svg";
export { ForwardRef as ReactComponent };